import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';

export default function ExamDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [showInstructions, setShowInstructions] = useState(true);

  const examData = {
    id: 1,
    course: 'الرياضيات المتقدمة',
    duration: 60,
    questions: 30,
    type: 'اختيار من متعدد',
    passingScore: 60,
    totalScore: 100,
    icon: 'ri-calculator-line',
    color: 'bg-blue-500',
    instructor: 'د. محمد أحمد',
    description: 'اختبار شامل يغطي جميع موضوعات الرياضيات المتقدمة للفصل الدراسي الأول',
    topics: [
      'التفاضل والتكامل',
      'المعادلات التفاضلية',
      'الجبر الخطي',
      'نظرية الأعداد',
      'الهندسة التحليلية'
    ],
    instructions: [
      'يجب الإجابة على جميع الأسئلة',
      'لا يمكن العودة للسؤال بعد الانتقال منه',
      'سيتم حفظ إجاباتك تلقائياً',
      'تأكد من اتصالك بالإنترنت طوال فترة الاختبار',
      'لا يسمح باستخدام الآلة الحاسبة',
      'سيتم إرسال الاختبار تلقائياً عند انتهاء الوقت'
    ]
  };

  const handleStartExam = () => {
    navigate(`/exam/${id}`);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-[#E8F5F3]">
      <Navbar />

      <div className="container mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/home')}
          className="flex items-center gap-2 text-slate-600 hover:text-[#0F2A3A] mb-6 font-semibold whitespace-nowrap cursor-pointer"
        >
          <i className="ri-arrow-right-line"></i>
          العودة للرئيسية
        </button>

        <div className="grid md:grid-cols-3 gap-8">
          {/* Main Content */}
          <div className="md:col-span-2 space-y-6">
            {/* Exam Header */}
            <div className={`${examData.color} rounded-2xl p-8 text-white`}>
              <div className="flex items-start justify-between mb-6">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-2xl">
                    <i className={`${examData.icon} text-4xl`}></i>
                  </div>
                  <div>
                    <h1 className="text-3xl font-bold mb-2">{examData.course}</h1>
                    <p className="text-white/80">المدرس: {examData.instructor}</p>
                  </div>
                </div>
                <span className="px-4 py-2 bg-white/20 rounded-full text-sm font-semibold">
                  متاح الآن
                </span>
              </div>
              <p className="text-white/90 text-lg">{examData.description}</p>
            </div>

            {/* Exam Topics */}
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h2 className="text-2xl font-bold text-[#0F2A3A] mb-6">المواضيع المشمولة</h2>
              <div className="grid md:grid-cols-2 gap-4">
                {examData.topics.map((topic, index) => (
                  <div key={index} className="flex items-center gap-3 p-4 bg-slate-50 rounded-xl">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#1ABC9C] rounded-lg">
                      <i className="ri-check-line text-white"></i>
                    </div>
                    <span className="text-slate-700 font-semibold">{topic}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Instructions */}
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-[#0F2A3A]">تعليمات الاختبار</h2>
                <button
                  onClick={() => setShowInstructions(!showInstructions)}
                  className="text-[#1ABC9C] hover:text-[#16a085] cursor-pointer"
                >
                  <i className={`text-2xl ${showInstructions ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
                </button>
              </div>

              {showInstructions && (
                <div className="space-y-4">
                  {examData.instructions.map((instruction, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <div className="w-6 h-6 flex items-center justify-center bg-[#1ABC9C]/10 rounded-full mt-1">
                        <span className="text-sm font-bold text-[#1ABC9C]">{index + 1}</span>
                      </div>
                      <p className="text-slate-700 leading-relaxed flex-1">{instruction}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Exam Info Card */}
            <div className="bg-white rounded-2xl shadow-lg p-6 sticky top-24">
              <h3 className="text-xl font-bold text-[#0F2A3A] mb-6">معلومات الاختبار</h3>
              
              <div className="space-y-4 mb-6">
                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <div className="flex items-center gap-3">
                    <i className="ri-time-line text-2xl text-[#1ABC9C]"></i>
                    <span className="text-slate-600">المدة</span>
                  </div>
                  <span className="font-bold text-[#0F2A3A]">{examData.duration} دقيقة</span>
                </div>

                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <div className="flex items-center gap-3">
                    <i className="ri-question-line text-2xl text-[#1ABC9C]"></i>
                    <span className="text-slate-600">الأسئلة</span>
                  </div>
                  <span className="font-bold text-[#0F2A3A]">{examData.questions} سؤال</span>
                </div>

                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <div className="flex items-center gap-3">
                    <i className="ri-file-list-line text-2xl text-[#1ABC9C]"></i>
                    <span className="text-slate-600">النوع</span>
                  </div>
                  <span className="font-bold text-[#0F2A3A]">{examData.type}</span>
                </div>

                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <div className="flex items-center gap-3">
                    <i className="ri-trophy-line text-2xl text-[#1ABC9C]"></i>
                    <span className="text-slate-600">الدرجة الكلية</span>
                  </div>
                  <span className="font-bold text-[#0F2A3A]">{examData.totalScore}</span>
                </div>

                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <div className="flex items-center gap-3">
                    <i className="ri-percent-line text-2xl text-[#1ABC9C]"></i>
                    <span className="text-slate-600">درجة النجاح</span>
                  </div>
                  <span className="font-bold text-[#0F2A3A]">{examData.passingScore}%</span>
                </div>
              </div>

              <button
                onClick={handleStartExam}
                className="w-full py-4 bg-[#1ABC9C] text-white text-lg font-bold rounded-xl hover:bg-[#16a085] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line ml-2"></i>
                بدء الاختبار
              </button>

              <div className="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded-xl">
                <div className="flex items-start gap-3">
                  <i className="ri-information-line text-xl text-yellow-600 mt-0.5"></i>
                  <p className="text-sm text-yellow-800 leading-relaxed">
                    تأكد من قراءة جميع التعليمات قبل البدء. لن تتمكن من إيقاف الاختبار بعد البدء.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
